import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'AM',
  quote: 'En dos semanas dejamos de tener la misma pelea de siempre. El protocolo SOS es lo primero que usamos y funciona de verdad. No lo puedo creer.',
  name: 'Andrea M.',
  location: 'Bogotá',
  role: 'En pareja hace 8 años'
}, {
  initials: 'CR',
  quote: 'Lo compramos en una crisis fuerte. Pensábamos que ya no había vuelta. El Tomo de Confianza nos salvó literalmente. Lo recomiendo a cualquier pareja aunque estén bien.',
  name: 'Carlos y Patricia R.',
  location: 'Buenos Aires',
  role: 'Casados hace 12 años'
}, {
  initials: 'VS',
  quote: 'Mi esposo no quería ni abrirlo. Al tercer día lo agarró él solo. Al séptimo me dijo que necesitábamos hablar. Fue la mejor conversación que tuvimos en años.',
  name: 'Valentina S.',
  location: 'Santiago de Chile',
  role: 'Mamá y esposa'
}];
export function Testimonials1() {
  return <TestimonialsSection title="Lo que Dicen Quienes Ya lo Tienen" testimonials={data} data-id="element-272" />;
}